import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class PiezometricHeadCalculationMethodModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (PiezometricHeadCalculationMethodModel._instance == null) PiezometricHeadCalculationMethodModel._instance = new PiezometricHeadCalculationMethodModel(authManager);
        return PiezometricHeadCalculationMethodModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'geo-sections/piezometric-head-calculation-methods', 'geo-sections/piezometric-head-calculation-methods/codelist');

        this.entityName = 'geo-sections.PiezometricHeadCalculationMethod';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Piezometric Head Calc Method';
        this.setLabel = 'Piezometric Head Calc Methods';

        this.browser = {
            name: 'default-geo-sections-piezometricheadcalculationmethod-browser',
            moduleName: 'default-geo-sections-piezometricheadcalculationmethod-browser',
            moduleTitle: 'Piezometric Head Calc Methods',
            moduleStateSlotName: 'default-geo-sections-piezometricheadcalculationmethod-browser',
        };

        this.editor = {
            name: 'default-geo-sections-piezometricheadcalculationmethod-editor',
            moduleName: 'default-geo-sections-piezometricheadcalculationmethod-editor',
            moduleTitle: 'Piezometric Head Calc Method',
            moduleStateSlotName: 'default-geo-sections-piezometricheadcalculationmethod-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
